// import { useEffect, useMemo, useState } from 'react'
// import { useStyles } from './styles'
// import { $userLanguage, $userToken } from '@/entities/user'
// import { useUnit } from 'effector-react'
// import { lang } from '@/shared/constants/lang'
// import { FirstStep } from '@/widgets/topUpSteam/firstStep'
// import { Icon } from '@/shared/ui/icon'
// import { SecondStep } from '@/widgets/topUpSteam/secondStep'
// import { $selectedCurrencyInfo, $steamPaymentFormData } from '@/entities/payments/store'
// import ButtonWrapper from '@/shared/ui/buttonWrapper'
// import { AppButton } from '@/shared/ui/button'
// import { darkTheme } from '@/shared/styles/theme/dark'
// import { goToAuth, goToMain, goToTransactionHistory, goToTransactionStatus } from '@/app/routing/events'
// import { useBackButton } from '@/shared/hooks/useBackButton'
// import { useHideNav } from '@/shared/hooks/useHideNav'
// import { postCreatePayment } from '@/entities/payments/api'
// import WebApp from '@twa-dev/sdk'
// import { updateTransactionStatus } from '@/entities/payments/events'
// import { getCurrencyRatesFx } from '@/entities/payments/effects'

export const TopUpSteamView = () => {
  //   /*

  //   useBackButton({ onBack: () => goToMain() })

  //   this cause rerender each time you do ANYTHING with component.
  //   Never use anonymous functions inside telegram buttons, they expect a function reference.

  //   this solutions prevents rerendering because we store the function reference  */
  //   const handleBack = useMemo(() => () => goToMain(), [])

  //   useBackButton({ onBack: handleBack })
  //   useHideNav()

  //   const { classes } = useStyles()
  //   const userLang = useUnit($userLanguage)
  //   const formData = useUnit($steamPaymentFormData)
  //   const selectedCurrencyInfo = useUnit($selectedCurrencyInfo)
  //   const texts = lang[userLang].pages.topUpSteamPage
  //   const [currStep, setCurrStep] = useState(0)
  //   const userToken = useUnit($userToken)
  //   const [isCreatingInvoice, setIsCreatingInvoice] = useState(false)

  //   const steps = [<FirstStep />, <SecondStep />]

  //   useEffect(() => {
  //     if (userToken) {
  //       getCurrencyRatesFx(userToken)
  //     } else {
  //       goToAuth()
  //     }
  //   }, [userToken])

  //   function handleSubmitPayment() {
  //     setIsCreatingInvoice(true)
  //     if (!userToken) {
  //       return goToAuth()
  //     }

  //   //   postCreatePayment(userToken, {
  //   //     ...formData,
  //   //     amount_usd: { value: selectedCurrencyInfo!.usdValue.toString()! ?? 0, isError: false },
  //   //   })
  //   //     .then((res) => {
  //   //       WebApp.openInvoice(res.invoice_url, (status) => {
  //   //         if (status === 'paid') {
  //   //           updateTransactionStatus('success')
  //   //           goToTransactionStatus()
  //   //           return
  //   //         }
  //   //         if (status === 'failed') {
  //   //           updateTransactionStatus('failed')
  //   //           goToTransactionStatus()
  //   //           return
  //   //         }
  //   //       })
  //   //     })
  //   //     .finally(() => {
  //   //       setIsCreatingInvoice(false)
  //   //     })
  //   // }

  //   return (
  //     <div className={classes.root}>
  //       <div
  //         className={classes.paymentHistory}
  //         onClick={() => goToTransactionHistory({ to: 'topUpSteam' })}
  //       >
  //         <Icon view="paymentHistory" />
  //       </div>

  //       <header className={classes.header}>
  //         <h1>{texts.heading}</h1>
  //         <h2>{`${texts.step} ${currStep + 1}/2`}</h2>
  //       </header>

  //       {steps[currStep]}
  //       <ButtonWrapper style={{ display: 'flex', flexDirection: 'row', gap: '12px', padding: '12px' }}>
  //         <StepsNavigation
  //           currStep={currStep}
  //           onForward={() => {
  //             setCurrStep(currStep + 1)
  //           }}
  //           onBackwards={() => {
  //             setCurrStep(currStep - 1)
  //           }}
  //           isCreatingInvoice={isCreatingInvoice}
  //           onSubmit={handleSubmitPayment}
  //         />
  //       </ButtonWrapper>
  //     </div>
  //   )
  // }

  // type StepsNavigationProps = {
  //   onForward: () => void
  //   onBackwards: () => void
  //   onSubmit: () => void
  //   currStep: number
  //   isCreatingInvoice: boolean
  // }

  // function StepsNavigation(props: StepsNavigationProps) {
  //   const { classes } = useStyles()
  //   const userLang = useUnit($userLanguage)
  //   const btnTexts = lang[userLang].pages.btnTexts
  //   const fData = useUnit($steamPaymentFormData)

  //   const isFirstStepBlocked =
  //     fData.login?.isError ||
  //     fData.amount?.isError ||
  //     !fData.login?.value ||
  //     !fData.amount?.value ||
  //     fData.amount?.value == '' ||
  //     fData.country?.value === ''

  //   if (props.currStep === 0)
  //     return (
  //       <AppButton
  //         onClick={props.onForward}
  //         fullWidth
  //         disabled={isFirstStepBlocked}
  //         style={{ height: darkTheme.sizes.button.height }}
  //       >
  //         {btnTexts.next}
  //       </AppButton>
  //     )
  //   else if (props.currStep === 1)
  //     return (
  //       <>
  //         <AppButton
  //           variant="secondary"
  //           fullWidth
  //           onClick={props.onBackwards}
  //           className={classes.button}
  //         >
  //           {btnTexts.back}
  //         </AppButton>
  //         <AppButton
  //           fullWidth
  //           onClick={() => {
  //             props.onSubmit()
  //           }}
  //           disabled={props.isCreatingInvoice}
  //           isLoading={props.isCreatingInvoice}
  //           className={classes.button}
  //         >
  //           <span>{`${btnTexts.pay} ${fData.amount?.value}`}</span>

  //           <Icon
  //             view="tgStar"
  //             width={20}
  //           />
  //         </AppButton>
  //       </>
  //     )
  return null
}
